"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import HeroCarousel from "@/components/ui/hero-carousel";

const CAROUSEL_IMAGES = [
  "/static/home/hero-illustration-carousel-01.webp",
  "/static/home/hero-illustration-carousel-02.webp",
  "/static/home/hero-illustration-carousel-03.webp",
  "/static/home/hero-illustration-carousel-04.webp",
];

type TwoColumnFeatureSectionProps = {
  showCarousel?: boolean;
};

export const TwoColumnFeatureSection = ({ showCarousel = false }: TwoColumnFeatureSectionProps) => {
  const t = useTranslations("home");
  return (
    <section className="bg-white px-4 section-y dark:bg-surface-dark">
      <div className="mx-auto max-w-6xl">
        <div className="relative grid items-stretch gap-0 overflow-hidden rounded-[56px_18px_56px_18px] bg-[#e8ecf3] shadow-card-lg dark:bg-surface-dark-raised dark:shadow-card-dark lg:grid-cols-2">
          <div className="absolute bottom-0 right-0 z-0 h-48 w-48 opacity-20 lg:h-72 lg:w-72">
            <Image
              src="/static/home/two-column-background.webp"
              alt=""
              fill
              className="object-contain object-bottom"
              sizes="288px"
              quality={60}
            />
          </div>

          <div className="relative h-[300px] lg:h-auto">
            <div className="absolute inset-0 overflow-hidden rounded-tl-[56px] rounded-tr-2xl lg:rounded-tr-none lg:rounded-bl-[56px]">
              {showCarousel ? (
                <HeroCarousel
                  fill
                  initialImages={CAROUSEL_IMAGES}
                  alt={t("twoColumn.imageAlt")}
                />
              ) : (
                <Image
                  src="/static/home/two-column-photo.webp"
                  alt={t("twoColumn.imageAlt")}
                  fill
                  className="object-cover"
                  sizes="(min-width: 1024px) 50vw, 100vw"
                  quality={60}
                />
              )}
            </div>
          </div>

          <div className="relative z-10 space-y-5 p-8 lg:p-12">
            <h2 className="italic text-brand-navy dark:text-white type-h2">
              {t("twoColumn.heading")}
            </h2>
            <p className="text-base font-semibold text-brand-navy dark:text-gray-100 lg:text-lg">
              {t("twoColumn.title")}
            </p>
            <p className="text-base leading-relaxed text-gray-800 dark:text-gray-300 lg:text-lg">
              {t("twoColumn.paragraph1")}
            </p>
            <p className="text-base leading-relaxed text-gray-800 dark:text-gray-300 lg:text-lg">
              {t("twoColumn.paragraph2")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
